<template>
  <svg
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="100%"
    height="100%"
    viewBox="0 0 36 36"
    preserveAspectRatio="none"
    id="pipeline_90_leftbottom"
    style="z-index: 1"
  >
    <title>{{ hint }}</title>
    <defs>
      <radialGradient fx="48" fy="-12" cx="32" cy="4" r="36" gradientUnits="userSpaceOnUse" id="lb-KeyGradient">
         <stop style="stop-opacity:1;stop-color:#3b3838" offset="0.12" />
         <stop style="stop-opacity:1;stop-color:#dedede" offset="0.69" />
         <stop style="stop-opacity:1;stop-color:#99a1af " offset="1" />
      </radialGradient>
      
        <!--https://tailwindcss.com/docs/colors gray-->
      <radialGradient fx="48" fy="-12" cx="32" cy="4" r="36" gradientUnits="userSpaceOnUse" id="lb-OilGradient">
        <stop style="stop-opacity: 1; stop-color: #868485 " offset="0.24"/>
        <stop style="stop-opacity: 1; stop-color: #99a1af" offset="0.69" />
        <stop style="stop-opacity: 1; stop-color: #868485 " offset="0.88" />
      </radialGradient>
      <path id="lb-main" d="m 36 36 L 36  12 C 28 12 24 8 24 0   L 0 0   C 0 24 12 36 36 36Z" />
    </defs>
    <g :visibility="fState[0]">
      <use href="#lb-main" fill="url(#lb-KeyGradient)" />
    </g>
    <g :visibility="fState[1]">
      <use href="#lb-main" fill="url(#lb-OilGradient)" />
    </g>
    <g :visibility="fState[2]">
      <use href="#lb-main" fill="url(#lb-KeyGradient)" />
    </g>
    <g :visibility="fState[3]">
      <use href="#lb-main" fill="url(#lb-KeyGradient)" />
    </g>
    <g :visibility="fState[4]">
      <use href="#lb-main" fill="url(#lb-KeyGradient)" />
    </g>
    <g :visibility="fState[5]">
      <use href="#lb-main" fill="url(#lb-KeyGradient)" />
    </g>
    <g :visibility="fState[10]">
      <use href="#lb-main" fill="url(#lb-KeyGradient)" />
    </g>
  </svg>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "pipeline_90_leftbottom",
  mixins: [MixinStates],
};
</script>
